export default __webpack_public_path__ + "static/media/DickGame.dc43cdbc.PNG";